module.exports = __webpack_public_path__ + "static/media/website-faq3.8ac2a4dd.png";